"use strict";

// Module API

function castAny(format, value) {
  return value;
}

module.exports = {
  castAny: castAny
};